// URLs use a readable project name, while the API continues to use the UUID
// stored in MariaDB.  Keep this mapping in the browser after projects load.
export function projectSlug(name) {
  const slug = String(name || 'project')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'project';
}

export function withProjectSlugs(projects = []) {
  const used = new Set();
  return projects.map(project => {
    const base = projectSlug(project.name);
    let slug = base;
    let index = 2;
    while (used.has(slug)) slug = `${base}-${index++}`;
    used.add(slug);
    return { ...project, slug };
  });
}

export function saveProjectSlugMap(projects = []) {
  const prepared = withProjectSlugs(projects);
  localStorage.setItem('projectSlugMap', JSON.stringify(prepared.map(({ id, slug }) => ({ id, slug }))));
  return prepared;
}

export function resolveProjectId(value) {
  if (!value) return value;
  try {
    const entries = JSON.parse(localStorage.getItem('projectSlugMap') || '[]');
    return entries.find(item => item.slug === value)?.id || value;
  } catch {
    return value;
  }
}
